import React from 'react';
import Navbar from './Navbar';
import Footer from '../legal/Footer';

const FAQ = () => {
  const faqs = [
    {
      question: "What is a Yapping Card?",
      answer: "A Yapping Card is a short text post where you can share quick updates, thoughts, or jokes. Think of it as a digital sticky note for your followers."
    },
    {
      question: "How do Fire Chats work?",
      answer: "Fire Chats are real-time discussion rooms focused on specific trending topics. They are designed for fast-paced, live interaction."
    },
    {
      question: "Is Blahbluh free to use?",
      answer: "Yes, Blahbluh is completely free to join and use. We may introduce optional premium features in the future."
    },
    {
      question: "How do I report inappropriate content?",
      answer: "You can report any post or user by clicking the three dots (...) menu associated with the content and selecting 'Report'."
    },
    {
      question: "Can I delete my account?",
      answer: "Yes, you can delete your account at any time from the Settings page. This action is permanent."
    }
  ];

  return (
    <div className="min-h-screen bg-[#0e0e0f] text-zinc-100 flex flex-col font-sans pt-20">
      <Navbar />
      <div className="container mx-auto px-4 py-8 max-w-3xl flex-1">
        <h1 className="text-3xl font-bold mb-8 text-center text-white">Frequently Asked Questions</h1>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-zinc-900 border border-white/10 rounded-2xl p-6 shadow-lg">
              <h3 className="text-xl font-bold text-white mb-2">{faq.question}</h3>
              <p className="text-zinc-400 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;